var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerBillboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#999999"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000, 25.000) scale(0.025000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.62-320h430.76q9.24 0 16.93-7.69 7.69-7.69 7.69-16.93V-720H300v375.38q0 9.24 7.69 16.93 7.69 7.69 16.93 7.69Zm0 40q-27.62 0-46.12-18.5Q260-317 260-344.62v-430.76q0-27.62 18.5-46.12Q297-840 324.62-840h430.76q27.62 0 46.12 18.5Q820-803 820-775.38v430.76q0 27.62-18.5 46.12Q783-280 755.38-280H324.62Zm-120 120q-27.62 0-46.12-18.5Q140-197 140-224.61v-470.77h40v470.77q0 9.23 7.69 16.92 7.69 7.69 16.93 7.69h470.76v40H204.62ZM300-800v480-480Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerBillboardIcon);
export default __webpack_public_path__ + "static/media/marker-billboard-icon.dd8a7a8516719d4d34174a5f76bea252.svg";
export { ForwardRef as ReactComponent };